<template></template>

<script setup>
import { onMounted, inject } from 'vue'

const props = defineProps([
    'data',
    'event'
])

const emitter = inject('emitter')

onMounted( () => {
    // console.log('Gtm component mounted:', JSON.parse(props.data))

    if ( props.data.length ) {
        setTimeout( () => {
            emitter.emit('track-event', { data: JSON.parse(props.data), event: props.event })
        }, 1000)
    }
})
</script>
